import { RadioGroup } from '@policygenius/mortar';
import omit from 'lodash/omit';
import { createUseStyles } from 'react-jss';

import getErrorMessage from 'forms/getErrorMessage';

import { RadioGroupFieldProps, RadioGroupFieldValues } from './types';
import styles from '../styles';
import useField from '../useField';

const useStyles = createUseStyles(styles);

const RadioGroupField = <Value extends RadioGroupFieldValues>({
  name,
  config,
  ...props
}: RadioGroupFieldProps) => {
  const classes = useStyles();

  const { input, meta } = useField<Value, HTMLInputElement>(name, { ...config, type: 'radio' });

  return (
    <div className={classes.fieldContainer}>
      <RadioGroup
        {...omit(input, 'type')}
        {...props}
        defaultValue={meta.initial}
        errorMessage={getErrorMessage(meta)}
        showGroupLabel
      />
    </div>
  );
};

export default RadioGroupField;
